export const translations = {
  en: {
    nav: {
      menu: "Menu",
      home: "Home",
      services: "Services",
      work: "Sellaris",
      process: "Process",
      about: "About",
      contact: "Contact",
    },
    hero: {
      srTitle: "Websites, apps, AI, SEO and strategy for businesses ready to grow.",
      tail: "for businesses ready to grow.",
      subtitle:
        "A design and engineering studio in central Pennsylvania. One senior team, in your time zone, in English and Spanish.",
      ctaPrimary: "Start a project",
      ctaSecondary: "See our services",
      pickerLabel: "Choose a service",
      services: [
        { key: "website", word: "Websites" },
        { key: "app", word: "Apps" },
        { key: "ai", word: "AI" },
        { key: "seo", word: "SEO" },
        { key: "strategy", word: "Strategy" },
      ],
    },
    clients: {
      title: "Trusted by teams across the U.S. and Latin America",
    },
    services: {
      eyebrow: "Services",
      title: "One team from the first idea to the first page of Google.",
      body: "Most businesses juggle a designer, a developer, an ad agency and someone for IT. We cover all of it, so nothing falls between vendors.",
      items: [
        {
          key: "ai",
          title: "AI & automation",
          body: "Chat assistants, document processing and automated workflows built on your own data. Your team stops doing work a machine can do.",
          points: ["AI assistants", "Workflow automation", "Data extraction"],
        },
        {
          key: "web",
          title: "Websites",
          body: "Fast, accessible sites designed to turn visitors into customers, on a platform your team can edit without calling us.",
          points: ["Design", "Development", "Hosting"],
        },
        {
          key: "apps",
          title: "Mobile & web apps",
          body: "iOS, Android and web apps, from the first prototype to the App Store.",
          points: ["iOS & Android", "Web platforms", "Customer portals"],
        },
        {
          key: "seo",
          title: "SEO & growth",
          body: "Technical SEO, content and analytics that get you found, with tracking that shows which work brings in customers.",
          points: ["Technical SEO", "Content", "Analytics"],
        },
        {
          key: "consulting",
          title: "Technology consulting",
          body: "Audits, roadmaps and build-or-buy advice. We tell you what to do, even when the answer is not to hire us.",
          points: ["Audits", "Roadmaps", "Vendor selection"],
        },
        {
          key: "software",
          title: "Custom software, ERP & CRM",
          body: "The systems that run your operation: billing, scheduling, inventory, and the connections between the tools and devices you already use.",
          points: ["ERP & CRM", "Integrations", "Hardware & sensors"],
        },
      ],
    },
    sellaris: {
      eyebrow: "Our product",
      title: "Sellaris",
      tagline: "A CRM for teams that sell with proposals and agreements.",
      body: "We built Sellaris in-house, and our clients' sales teams use it every day. It covers the pipeline, proposals, signed agreements and your product catalog, on web and mobile.",
      features: [
        { key: "opportunities", title: "Opportunities", body: "Follow every lead and deal through the pipeline." },
        { key: "proposals", title: "Proposals", body: "Build and send professional proposals in minutes." },
        { key: "agreements", title: "Agreements", body: "Turn a won proposal into a signed agreement in the app." },
        { key: "skus", title: "Product catalog", body: "Every product and service you sell, with prices." },
      ],
      mobileLabel: "On iOS, Android and the web",
      cta: "Request a demo",
    },
    process: {
      eyebrow: "Process",
      title: "How a project runs",
      body: "No black box. You see working software every week and know where the budget goes.",
      steps: [
        { title: "Consult", body: "We learn your business, agree on what success looks like and put the scope in writing." },
        { title: "Design", body: "Wireframes and clickable prototypes you can test before production code." },
        { title: "Build", body: "Weekly releases you can see and use, not one big reveal at the end." },
        { title: "Grow", body: "Launch, measure, improve. SEO, analytics and support keep it working after go-live." },
      ],
    },
    about: {
      eyebrow: "About",
      title: "Senior team. Your time zone. English and Spanish.",
      body: "We're based in central Pennsylvania, near Penn State, and work with companies across the U.S. and Latin America. The people who plan your project are the people who build it.",
      stats: [
        { value: "10+", label: "Years of combined experience" },
        { value: "2", label: "Languages: English and Spanish" },
        { value: "24/7", label: "Support for live systems" },
      ],
      points: [
        { title: "Senior people only", body: "No hand-offs to juniors after the sales call." },
        { title: "U.S. hours", body: "Same time zone, direct lines, quick answers." },
        { title: "Bilingual", body: "We work with your team and your customers in English and Spanish." },
        { title: "Judged by results", body: "We measure success by leads, sales and hours saved." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Tell us what you're building.",
      body: "Choose what you need, add a line about the project and send it. Someone from the team will reply.",
      pickLabel: "I need help with",
      messageLabel: "About the project",
      messagePlaceholder: "A few words about your business and goals",
      sendEmail: "Send by email",
      whatsapp: "WhatsApp",
      linkedin: "LinkedIn",
      emailSubject: "New project inquiry",
      emailIntro: "Hi Near Shore Design, I'd like help with:",
      info: {
        phoneLabel: "Phone",
        emailLabel: "Email",
        locationLabel: "Location",
        location: "Central Pennsylvania, USA",
      },
    },
    footer: {
      tagline: "Design, engineering and growth for businesses that want to move faster.",
      rights: "All rights reserved",
      sections: {
        company: "Company",
        services: "Services",
        contact: "Contact",
      },
    },
    lang: {
      switchTo: "Switch language",
    },
  },
  es: {
    nav: {
      menu: "Menú",
      home: "Inicio",
      services: "Servicios",
      work: "Sellaris",
      process: "Proceso",
      about: "Nosotros",
      contact: "Contacto",
    },
    hero: {
      srTitle: "Sitios web, apps, IA, SEO y estrategia para negocios listos para crecer.",
      tail: "para negocios listos para crecer.",
      subtitle:
        "Un estudio de diseño e ingeniería en el centro de Pensilvania. Un solo equipo senior, en tu zona horaria, en inglés y español.",
      ctaPrimary: "Empezar un proyecto",
      ctaSecondary: "Ver servicios",
      pickerLabel: "Elige un servicio",
      services: [
        { key: "website", word: "Sitios web" },
        { key: "app", word: "Apps" },
        { key: "ai", word: "IA" },
        { key: "seo", word: "SEO" },
        { key: "strategy", word: "Estrategia" },
      ],
    },
    clients: {
      title: "Equipos en EE. UU. y Latinoamérica confían en nosotros",
    },
    services: {
      eyebrow: "Servicios",
      title: "Un solo equipo, de la primera idea a la primera página de Google.",
      body: "Muchas empresas coordinan a un diseñador, un desarrollador, una agencia de anuncios y alguien para sistemas. Nosotros cubrimos todo, para que nada se pierda entre proveedores.",
      items: [
        {
          key: "ai",
          title: "IA y automatización",
          body: "Asistentes, procesamiento de documentos y flujos automatizados con tus propios datos. Tu equipo deja de hacer el trabajo que puede hacer una máquina.",
          points: ["Asistentes con IA", "Automatización", "Extracción de datos"],
        },
        {
          key: "web",
          title: "Sitios web",
          body: "Sitios rápidos y accesibles, diseñados para convertir visitas en clientes, en una plataforma que tu equipo puede editar sin llamarnos.",
          points: ["Diseño", "Desarrollo", "Hosting"],
        },
        {
          key: "apps",
          title: "Apps móviles y web",
          body: "Apps para iOS, Android y web, desde el primer prototipo hasta la App Store.",
          points: ["iOS y Android", "Plataformas web", "Portales de clientes"],
        },
        {
          key: "seo",
          title: "SEO y crecimiento",
          body: "SEO técnico, contenido y analítica para que te encuentren, con mediciones que muestran qué trae clientes.",
          points: ["SEO técnico", "Contenido", "Analítica"],
        },
        {
          key: "consulting",
          title: "Consultoría tecnológica",
          body: "Auditorías, hojas de ruta y asesoría sobre construir o comprar. Te decimos qué hacer, aunque la respuesta no sea contratarnos.",
          points: ["Auditorías", "Hojas de ruta", "Selección de proveedores"],
        },
        {
          key: "software",
          title: "Software a medida, ERP y CRM",
          body: "Los sistemas que mueven tu operación: facturación, agenda, inventario y la conexión entre las herramientas y equipos que ya usas.",
          points: ["ERP y CRM", "Integraciones", "Hardware y sensores"],
        },
      ],
    },
    sellaris: {
      eyebrow: "Nuestro producto",
      title: "Sellaris",
      tagline: "Un CRM para equipos que venden con propuestas y acuerdos.",
      body: "Creamos Sellaris internamente y los equipos de ventas de nuestros clientes lo usan a diario. Cubre el pipeline, las propuestas, los acuerdos firmados y tu catálogo de productos, en web y móvil.",
      features: [
        { key: "opportunities", title: "Oportunidades", body: "Sigue cada lead y negocio a lo largo del pipeline." },
        { key: "proposals", title: "Propuestas", body: "Crea y envía propuestas profesionales en minutos." },
        { key: "agreements", title: "Acuerdos", body: "Convierte una propuesta ganada en un acuerdo firmado en la app." },
        { key: "skus", title: "Catálogo", body: "Todos tus productos y servicios, con sus precios." },
      ],
      mobileLabel: "En iOS, Android y web",
      cta: "Solicitar una demo",
    },
    process: {
      eyebrow: "Proceso",
      title: "Cómo trabajamos",
      body: "Sin cajas negras. Ves software funcionando cada semana y sabes en qué se usa el presupuesto.",
      steps: [
        { title: "Consultar", body: "Entendemos tu negocio, definimos qué es el éxito y dejamos el alcance por escrito." },
        { title: "Diseñar", body: "Wireframes y prototipos navegables que puedes probar antes del código final." },
        { title: "Construir", body: "Entregas semanales que puedes ver y usar, no una gran sorpresa al final." },
        { title: "Crecer", body: "Lanzar, medir y mejorar. SEO, analítica y soporte después de salir en vivo." },
      ],
    },
    about: {
      eyebrow: "Nosotros",
      title: "Equipo senior. Tu zona horaria. Inglés y español.",
      body: "Estamos en el centro de Pensilvania, cerca de Penn State, y trabajamos con empresas en EE. UU. y Latinoamérica. Quienes planean tu proyecto son quienes lo construyen.",
      stats: [
        { value: "10+", label: "Años de experiencia combinada" },
        { value: "2", label: "Idiomas: inglés y español" },
        { value: "24/7", label: "Soporte para sistemas en producción" },
      ],
      points: [
        { title: "Solo perfiles senior", body: "Nadie te pasa a un junior después de la venta." },
        { title: "Horario de EE. UU.", body: "Misma zona horaria, contacto directo, respuestas rápidas." },
        { title: "Bilingües", body: "Trabajamos con tu equipo y tus clientes en inglés y español." },
        { title: "Medidos por resultados", body: "Medimos el éxito en leads, ventas y horas ahorradas." },
      ],
    },
    contact: {
      eyebrow: "Contacto",
      title: "Cuéntanos qué quieres construir.",
      body: "Elige lo que necesitas, agrega una línea sobre el proyecto y envíalo. Alguien del equipo te responderá.",
      pickLabel: "Necesito ayuda con",
      messageLabel: "Sobre el proyecto",
      messagePlaceholder: "Unas palabras sobre tu negocio y tus objetivos",
      sendEmail: "Enviar por correo",
      whatsapp: "WhatsApp",
      linkedin: "LinkedIn",
      emailSubject: "Consulta de proyecto",
      emailIntro: "Hola Near Shore Design, me gustaría ayuda con:",
      info: {
        phoneLabel: "Teléfono",
        emailLabel: "Correo",
        locationLabel: "Ubicación",
        location: "Centro de Pensilvania, EE. UU.",
      },
    },
    footer: {
      tagline: "Diseño, ingeniería y crecimiento para empresas que quieren avanzar más rápido.",
      rights: "Todos los derechos reservados",
      sections: {
        company: "Empresa",
        services: "Servicios",
        contact: "Contacto",
      },
    },
    lang: {
      switchTo: "Cambiar idioma",
    },
  },
};
